 <!-- ********************MOBILE-VIEW******************** -->


        <div class="divLineup_mobile" style="background-color: white;">

               <div fxLayout="row"  fxFlex="37">

                    <span>

                        <img class="image_mobile" src="{{premiere.mobilethumbimage}}"/>

                    </span>

                </div>

                <div fxFlex="63" fxLayout="row wrap">

                    <h3   class="spotlightsDate_mobile">
                        {{premiere.cinejoySpotlightsSchedule[0]?.scheduleTimeText | date:'EEE, MMM d, y, h:mm:ss a'}} {{timezone}}<br>
                    </h3>

                    <h3 fxFlex.lt-md="100"  class="spotLightsTitle_mobile">{{premiere.name}}</h3>
                  <a class="spotLightsTitle_mobile" style="font-size: 12px;margin-bottom: 5px;" [href]="groupshareUrl" target="_blank">Experience Spotlight with Group</a>

                    <div fxLayoutAlign="start" fxLayout="row" style="margin-left: 10px;"
                         class="spotlight_button_mobile" fxLayoutGap="6px" *ngIf="!archive">

             <button id="btn_mobile" (click)="open(premiere.eventId, premiere, 'Buy')" *ngIf="(!isBuyButtonActive)"
             appTrackClick
            [buttonProps]="{
                title:'spotlight_buy',
                customeId:premiere.eventId,
                feature_context:'CINEJOY'
                }"
             >{{bulkPurchaseEnabled?'Buy One tix':'Buy'}}</button>
                        <button
                        id="btn_mobile"
                        (click)="initiateBulkPurchase(premiere.eventId)"
                        *ngIf="bulkPurchaseEnabled&&!isBuyButtonActive"               
                        appTrackClick
                        [buttonProps]="{
                            title:'spotlight_buy_bulk',
                            customeId:premiere.eventId,
                            feature_context:'CINEJOY'
                        }">
                        Buy Bulk Tix
                      </button>
             <button id="btn_mobile" (click)="redirect()"  [disabled] ="joinButtonDisabled">Join</button>
             <button id="btn_mobile" (click)="gotoMoreInfo(premiere.eventId,premierename,premiere.event)"  
             appTrackClick
             [buttonProps]="{
               title:'spotlight_more_info',
               customeId:premiere.eventId,
               feature_context:'CINEJOY'
           }">More Info</button>

             <button *ngIf="!premiere.bookmarked" 
                style="border: none; background-color: white;"
                (click)="bookmarkEvent(premiere.eventId, true)"
                appTrackClick
                [buttonProps]="{
                  title:'spotlight_bookMark',
                  customeId:premiere.eventId,
                  feature_context:'CINEJOY'
              }"
                >
                <img src="../../../../../assets/images/mobilepass.png" alt="Bookmark Image" width="38px" height="34px" />
            </button>

            <button *ngIf="premiere.bookmarked" 
                style="border: none; background-color: white;"
                (click)="alreadyBookmarkEvent(true)">
                <img src="../../../../../assets/images/mobilebookmarked.png" alt="Bookmark Image" width="38px" height="34px" />
            </button>

             <button id="btn_mobile" (click)="openDialog(premiere)" style="margin-top: 5px;"
             *ngIf="(isBuyButtonActive && createGroup) ">
             <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
             <ng-container *ngIf="exsistingGroup">Manage Group</ng-container></button>
         </div>

         <div fxLayoutAlign="start" fxLayout="row" style="margin-left: 11px; text-align: center !important;"
              class="spotlight_button_mobile" fxLayoutGap="6px" *ngIf="archive">

                        <button id="btn_mobile" (click)="gotoMoreInfo(premiere.eventId,premierename,premiere.type)">More Info</button>

                    </div>

                </div>

        </div>

      <!-- ********************MOBILE-VIEW ENDED******************** -->
